import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { SERVER_URL } from "../../api/url";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import useStore from "../../store/information";



const LoginForm = () => {
  const [error,setError]=useState("")
   const [message,setMessage]=useState("")
    const { Name,Id } = useStore();
  const initialValues = {
    email: "",
    password: "",
  };
    const [searchParams] = useSearchParams();
    const [showPasswordModal, setShowPasswordModal] = useState(false);
 const [errorForget,setErrorForget]=useState("")
   const [messageForget,setMessageforget]=useState("")
const [openCode,setOpenCode]=useState("")
     const [messageEmail,setMessageEmail]=useState("")
       const [countdown,setCountdown]=useState(0)
    const navigate = useNavigate();
    const [open,setOpen]=useState(0)
  const [email,setEmail]=useState("")

useEffect(() => {
  let timer;
  if (countdown > 0) {
    timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
  }
  return () => clearInterval(timer);
}, [countdown]);



  const validationSchema = yup.object({
    email: yup
      .string()
      .email("Invalid Email Format")
      .test("complete-domain", "Invalid Email Address", (value) => /@.+\..+/.test(value))
      .required("Email is required"),

    password: yup.string().required("Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
 

    const payload = {
      email: values.email,
      password: values.password,
      confirm_password: values.password,
      notificationToken:"",
    };

    try {
      const response = await axios.post(`${SERVER_URL}/auth/login`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200) {
       setMessage("Login Successfully")
        resetForm();
         const decoded = jwtDecode(response.data.data);
         localStorage.setItem('userToken', response.data.data);
           localStorage.setItem('userName', decoded.name);
               localStorage.setItem('userEmail', decoded.email);
               localStorage.setItem('userPhoneNumber', decoded.phoneNumber);
               localStorage.setItem('userRole', decoded.role.name);
               localStorage.setItem('userId', decoded._id);
    //             if(Name && Id){
    //   navigate('/payment', { state: { courseID:Id,courseName:Name } });
    //  }else{
        
    //  }
     navigate("/")
       
      } else {
          setError("Something Went Wrong,Please try again")
      }
    } catch (err) {
      setError(err.response?.data?.error)
    }

    setSubmitting(false);
  };


  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ isSubmitting }) => (
          <div className="react-blog-form">
            <h2 className="contact-title">
              Welcome <br /> Login to your account
            </h2>
            <div id="blog-form" className="blog-form">
              <Form id="contact-form">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="email" type="email" placeholder="Enter Your Email" />
                      <ErrorMessage className="errorComp" name="email" component="div" />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="password" type="password" placeholder="Enter Your Password" />
                      <ErrorMessage className="errorComp" name="password" component="div" />
                    </div>
                  </div>
          <div style={{display:"flex",justifyContent:"end",gap:10,alignItems:"center"}}>
                   <h4 className="login-title">
           <Link to="#" >
             <div
                    
                      onClick={() => setShowPasswordModal(true)}
                      className=""
                    >
                      Forget Password
                    </div>
           </Link>
            
            </h4>
                 <h4 className="login-title">
      
             <div className="">/</div>
      
            
            </h4>
                   <h4 className="login-title">
           <Link to="/register" >Register</Link>
            
            </h4>
      
          </div>
                                         {messageForget && (
          <div className="alert alert-info">
            {messageForget}
           
          </div>
        )}
           {message && (
          <div className="alert alert-info">
            {message}
           
          </div>
        )}
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}
                  <div className="col-lg-12">
                    <button type="submit" className="back-btn" disabled={isSubmitting}>
                      {isSubmitting ? "Logging in..." : "Login"}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-arrow-right"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </button>
                  </div>
              
                </div>
              </Form>
            </div>
          </div>
        )}
      </Formik>
{showPasswordModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <h3>Forget Password</h3>

      <Formik
        initialValues={{
          email: "",
          code: ["", "", "", ""],
          password: "",
        }}
        onSubmit={async (values, { resetForm }) => {
          try {
            if (open === 0) {
              // Step 1: Send OTP
              const response = await axios.post(`${SERVER_URL}/auth/forgot_password?isweb=true&email=${values.email}&count=60`, {
                email: values.email,
              });
              setOpen(1); // Move to OTP input step
              setMessageEmail(response.data?.data?.message); // optional
              setOpenCode(response.data?.data?.otp)
              console.log(response?.data)
              setErrorForget("");
            
              setCountdown(60); // Start countdown
            } else if (open === 2) {
                const numericCodeArray = values.code.map((c) => parseInt(c, 10));
              const response = await axios.post(`${SERVER_URL}/auth/reset_password/${openCode}`, {
                code: numericCodeArray,
                password: values.password,
              });
              setMessageforget("Password updated successfully");
              setShowPasswordModal(false);
              setError("");
              resetForm();
              setOpen(0); // Reset steps
            }else if(open===1){
                if (!openCode) {
    return setErrorForget("Please authorization by clicking confirm your email");
  }
  setOpen(2);
            }
          } catch (err) {
            setErrorForget(err.response?.data?.error || "Something went wrong");
            setMessageEmail("")
          }
        }}
      >
        {({ values }) => (
          <Form>
            {/* Step 1: Email Input */}
            {open === 0 && (
              <div className="form-group">
                <Field name="email" type="email" placeholder="Enter Email" className="form-control rounded-input" />
                <ErrorMessage name="email" component="div" className="errorComp" />
              </div>
            )}

           
          {open === 1 && (
  <>
    <div className="form-group d-flex gap-2 justify-content-center">
      {values.code.map((val, idx) => (
        <Field
          key={idx}
          name={`code[${idx}]`}
          type="text"
          maxLength="1"
          className="form-control rounded-input text-center"
        />
      ))}
    </div>
    <div className="d-flex gap-2 justify-content-center align-items-center mt-2">
      <div className="text-sm">
        Wait for {countdown < 10 ? `00:0${countdown}` : `00:${countdown}`}
      </div>

      <Link to="#">
        <div
          className="text-primary"
          onClick={async () => {
            try {
              await axios.post(`${SERVER_URL}/auth/forgot_password?isweb=true&email=${values.email}&count=60`, {
                email: values.email|| email,
              });
              setCountdown(60); // restart timer
              setErrorForget("");
            } catch (err) {
              setErrorForget(err.response?.data?.error || "Failed to resend OTP");
            }
          }}
          style={{ cursor: countdown === 0 ? "pointer" : "not-allowed", opacity: countdown === 0 ? 1 : 0.5 }}
        >
          Resend OTP
        </div>
      </Link>
    </div>

    {/* <div className="mt-2 d-flex justify-content-end gap-2">
      <button type="button" className="btn btn-gray" onClick={() => setShowPasswordModal(false)}>
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-primary"
      onClick={() => {
  if (!openCode) {
    return setErrorForget("Please authorization by clicking confirm your email");
  }
  setOpen(2);
}}
 // Move to password step
      >
        Next
      </button>
    </div> */}
  </>
)}


         
            {open === 2 && (
              <div className="form-group">
                <Field name="password" type="password" placeholder="New Password" className="form-control rounded-input" />
                <ErrorMessage name="password" component="div" className="errorComp" />
              </div>
            )}
    {messageEmail && (
          <div className="alert alert-info">
            {messageEmail}
           
          </div>
        )}
            {errorForget && <div className="alert alert-danger">{errorForget}</div>}

            <div className="d-flex justify-content-end gap-2 mt-3">
             
                <button type="button" className="btn btn-gray" onClick={() => setShowPasswordModal(false)}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                 {open===1 ?  "Next":" Submit"}
                </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  </div>
)}



      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0; left: 0;
            width: 100%; height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }
          .modal-content {
            background: white;
            padding: 30px;
            border-radius: 8px;
            width: 100%;
            max-width: 400px;
          }
          .form-group {
            margin-bottom: 15px;
          }
            .rounded-input {
  border-radius: 8px;
}
          .form-group input {
            width: 100%;
            padding: 10px;
          }
          .errorComp {
            color: red;
            font-size: 12px;
          }
            .form-group input:focus {
  border-color: #007bff !important;
 
  outline: none;
}

        `}
      </style>
    </>
  );
};

export default LoginForm;
